// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BitMaskMessage, BitMaskMessageT, verifyBitMaskMessage } from "./bit-mask-message";
import {
  EncodedMessageContent,
  unionToEncodedMessageContent,
  unionListToEncodedMessageContent,
} from "./encoded-message-content";
import { OneHotMessage, OneHotMessageT, verifyOneHotMessage } from "./one-hot-message";

export class Message implements flatbuffers.IUnpackableObject<MessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Message {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMessage(bb: flatbuffers.ByteBuffer, obj?: Message): Message {
    return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMessage(bb: flatbuffers.ByteBuffer, obj?: Message): Message {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  contentType(): EncodedMessageContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : EncodedMessageContent.NONE;
  }

  content<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addContentType(builder: flatbuffers.Builder, contentType: EncodedMessageContent) {
    builder.addFieldInt8(0, contentType, EncodedMessageContent.NONE);
  }

  static addContent(builder: flatbuffers.Builder, contentOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, contentOffset, 0);
  }

  static endMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // content
    return offset;
  }

  static createMessage(
    builder: flatbuffers.Builder,
    contentType: EncodedMessageContent,
    contentOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Message.startMessage(builder);
    Message.addContentType(builder, contentType);
    Message.addContent(builder, contentOffset);
    return Message.endMessage(builder);
  }

  unpack(): MessageT {
    return new MessageT(
      this.contentType(),
      (() => {
        const temp = unionToEncodedMessageContent(this.contentType(), this.content.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: MessageT): void {
    _o.contentType = this.contentType();
    _o.content = (() => {
      const temp = unionToEncodedMessageContent(this.contentType(), this.content.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): MessageT {
    const t = new MessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("content_type")) {
      t.contentType = this.contentType();
    }
    if (fieldSet.has("content")) {
      t.content = (() => {
        const temp = unionToEncodedMessageContent(this.contentType(), this.content.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class MessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public contentType: EncodedMessageContent = EncodedMessageContent.NONE,
    public content: BitMaskMessageT | OneHotMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.content === null || this.content === undefined) {
      throw new Error('Required field "content" is not set');
    }
    const content = builder.createObjectOffset(this.content);

    return Message.createMessage(builder, this.contentType, content);
  }

  clone(): MessageT {
    const obj = new MessageT();
    obj.contentType = this.contentType;
    obj.content =
      this.content !== null && typeof (this.content as any).clone === "function"
        ? (this.content as any).clone()
        : this.content;
    return obj;
  }

  equals(other: MessageT): boolean {
    if (this.contentType !== other.contentType) return false;
    if (this.content !== null && other.content !== null) {
      if (typeof (this.content as any).equals === "function") {
        if (!(this.content as any).equals(other.content)) return false;
      } else if (this.content !== other.content) return false;
    } else if (this.content !== other.content) return false;
    return true;
  }
}

export function verifyMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "content");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // OneHotMessage
            {
              const o = verifier.readInt32(pos);
              verifyOneHotMessage(verifier, pos + o);
            }
            break;
          case 2: // BitMaskMessage
            {
              const o = verifier.readInt32(pos);
              verifyBitMaskMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "content");
  } finally {
    verifier.popDepth();
  }
}
